import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { Observable } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { Response } from '../models/response.interface';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private restApiService: RestApiService, private translateService: TranslateService) {
  }

  validateHash(hash: string): Observable<any> {
    const url = `transactions/${hash}?lang=${this.getLang()}`;
    return this.restApiService.get(url);
  }

  getLang(){
    return this.translateService.currentLang;
  }

  submitForm(hash: string, formData: any): Observable<any> {

    // const responseError = {
    //   success: false,
    //   validationErrors: {
    //     addresseePhone: "Ingrese un tel válido", //o no viene si no hay error
    //     addresseeEmail: "Error en verificación de email" //o no viene si no hay error
    //   }
    // }

    // const responseOk = {
    //   success: true
    // }

    return this.restApiService.post(
      `transactions/${hash}?lang=${this.getLang()}`,
      formData,
      { responseType: 'json' }
    );
  }


  validateToken(params: any): Observable<any> {
    const url = `validateRecaptcha`;
    return this.restApiService.get(url, params);
  }
}
